var createStylesheet = (chunkId, fullhref, resolve, reject) => {
	var linkTag = document.createElement("link");

	linkTag.rel = "stylesheet";
	linkTag.type = "text/css";
	var onLinkComplete = (event) => {
		// avoid mem leaks.
		linkTag.onerror = linkTag.onload = null;
		if (event.type === 'load') {
			resolve();
		} else {
			var errorType = event && (event.type === 'load' ? 'missing' : event.type);
			var realHref = event && event.target && event.target.href || fullhref;
			var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + realHref + ")");
			err.code = "CSS_CHUNK_LOAD_FAILED";
			err.type = errorType;
			err.request = realHref;
			linkTag.parentNode.removeChild(linkTag)
			reject(err);
		}
	}
	linkTag.onerror = linkTag.onload = onLinkComplete;
	linkTag.href = fullhref;

	document.head.appendChild(linkTag);
	return linkTag;
};
var findStylesheet = (href, fullhref) => {
	var existingLinkTags = document.getElementsByTagName("link");
	for(var i = 0; i < existingLinkTags.length; i++) {
		var tag = existingLinkTags[i];
		var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
		if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return tag;
	}
	var existingStyleTags = document.getElementsByTagName("style");
	for(var i = 0; i < existingStyleTags.length; i++) {
		var tag = existingStyleTags[i];
		var dataHref = tag.getAttribute("data-href");
		if(dataHref === href || dataHref === fullhref) return tag;
	}
};
var loadStylesheet = (chunkId) => {
	return new Promise((resolve, reject) => {
		var href = __webpack_require__.miniCssF(chunkId);
		var fullhref = __webpack_require__.p + href;
		if(findStylesheet(href, fullhref)) return resolve();
		createStylesheet(chunkId, fullhref, resolve, reject);
	});
}
// object to store loaded CSS chunks
var installedCssChunks = {
	2143: 0
};

__webpack_require__.f.miniCss = (chunkId, promises) => {
	var cssChunks = {"28":1,"239":1,"263":1,"325":1,"342":1,"354":1,"461":1,"526":1,"797":1,"817":1,"824":1,"909":1,"1003":1,"1031":1,"1064":1,"1080":1,"1089":1,"1111":1,"1458":1,"1483":1,"1613":1,"1636":1,"1697":1,"1705":1,"1789":1,"1805":1,"1824":1,"1907":1,"1962":1,"2069":1,"2098":1,"2296":1,"2301":1,"2370":1,"2580":1,"2626":1,"2673":1,"2725":1,"2735":1,"2791":1,"2879":1,"2917":1,"3113":1,"3129":1,"3160":1,"3315":1,"3333":1,"3435":1,"3690":1,"3788":1,"3907":1,"3992":1,"3999":1,"4106":1,"4179":1,"4288":1,"4304":1,"4441":1,"4507":1,"4836":1,"4884":1,"4910":1,"5086":1,"5218":1,"5237":1,"5276":1,"5331":1,"5446":1,"5450":1,"5607":1,"5766":1,"5805":1,"5951":1,"6151":1,"6242":1,"6289":1,"6446":1,"6552":1,"6581":1,"6605":1,"6872":1,"6962":1,"7107":1,"7450":1,"7461":1,"7472":1,"7508":1,"7727":1,"7766":1,"7855":1,"7895":1,"7922":1,"8051":1,"8080":1,"8108":1,"8338":1,"8351":1,"8353":1,"8551":1,"8765":1,"8817":1,"8859":1,"8916":1,"9141":1,"9313":1,"9371":1,"9407":1,"9450":1,"9494":1,"9611":1,"9613":1,"9716":1,"9722":1,"9752":1,"9818":1};
	if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
	else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
		promises.push(installedCssChunks[chunkId] = loadStylesheet(chunkId).then(() => {
			installedCssChunks[chunkId] = 0;
		}, (e) => {
			delete installedCssChunks[chunkId];
			throw e;
		}));
	}
};

// no hmr